/* eslint-disable */
/**
*   QUOTER FOR LOANS FOR RPP / ISD
*
*/
// var moment = require('moment')
import moment from 'moment'

var inputsPoliza = {
  codigoMoneda: null,
  moneda: null,
  montoTransferido: null,
  temporalidad: null,
  periodoGarantizado: null,
  tasaVentaAnual: null,
  tasaVentaMensual: null,
  devolucion: null,
  devolucionInicial: null,
  devolucionOriginal: null,
  rentaMensual: null,
  rentaSimple: null,
  inicioPoliza: null,
  rentaDoble: null,
  rentaDobleMonto: null,
  periodosDiferidos: null,
  rentasDoblesPorPagar: null,
  totalRentasPorPagar: null,
  fechaInicioPago: null,
  mesSolicitud: null
}

var inputsPrestamo = {
  prestamo: 0,
  cuotas: 0,
  pagoSimple: 2436.37, // DATO FIJO
  periodoGracia: 0,
  periodoGraciaExtraDiferido: 0,
  cuotasDobles: 'NO'
}

var inputsCalculados = {
  prestamoParaCuota: 0,
  valorActualDevolucion: 0,
  tasaPrestamoMensual: 0,
  tasaPrestamoAnual: 0,
  valorFuturoPrestamoAdicional: 0,
  valorFuturoPrestamoAdicionalDoble: 0,
  cuotaGracia: 0,
  prestamoMaxGracia: 0,
  rentasGarantizadasPorPagar: 0
}

var getMinLoan = function () { return 5000 }
var getSpreadAnnualInterestRate = function () { return 0.02 }
var PV = function (rate, periods, payment, future, type) {
  // Initialize type
  var type = (typeof type === 'undefined') ? 0 : type

  // Evaluate rate and periods (TODO: replace with secure expression evaluator)
  rate = eval(rate)
  periods = eval(periods)

  // Return present value
  if (rate === 0) {
    return - payment * periods - future
  } else {
    return (((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 +rate * type) - future) / Math.pow(1 + rate, periods)
  }
}
var FV = function (rate, nper, pmt, pv, type) {
  // eslint-disable-next-line
  var pow = Math.pow(1 + rate, nper), fv
  if (rate) {
    fv = (pmt * (1 + rate * type) * (1 - pow) / rate) - pv * pow
  } else {
    fv = -1 * (pv + pmt * nper)
  }
  return fv.toFixed(2)
}
var PMT = function (rate, nperiod, pv, fv, type) {
  if (!fv) fv = 0
  if (!type) type = 0

  if (rate === 0) return -(pv + fv)/nperiod

  var pvif = Math.pow(1 + rate, nperiod)
  var pmt = rate / (pvif - 1) * -(pv * pvif + fv)

  if (type === 1) {
    pmt /= (1 + rate)
  }

  return pmt
}
var roundNumber = function (rnum, rlength) { 
  var newnumber = Math.round(rnum * Math.pow(10, rlength)) / Math.pow(10, rlength)
  return newnumber;
}

var quoter = {
  // Límites de préstamo por tipo de moneda (PEN/USD)
  loanLimits: {
    min: {
      PEN: 1000,
      USD: 270
    }
  },
  setInfoDataPolicy (data) {
    let currentDate = new Date()
    inputsPoliza.codigoMoneda = data.moneda.codigo
    inputsPoliza.fechaInicioPago = data.fechaInicioPago
    inputsPoliza.rentaMensual = data.ingresoMensual
    inputsPoliza.rentaSimple = data.ingresoMensual
    inputsPoliza.rentaDoble = data.ingresosDobles //-- SON MESES
    inputsPoliza.rentaDobleMonto = data.ingresosDobles > 0 ? data.ingresoMensual*2 : 0 //-- ES MONTO
    inputsPoliza.montoTransferido = data.montoTransferido
    inputsPoliza.periodosDiferidos = data.periodoDiferido == undefined ? 0 : data.periodoDiferido
    inputsPoliza.devolucion = data.devolucion.porcentaje/100
    inputsPoliza.devolucionInicial = data.devolucion.monto
    inputsPoliza.devolucionOriginal = data.devolucionActual
    inputsPoliza.periodoGarantizado = data.periodoGarantizado
    inputsPoliza.temporalidad = data.periodoGarantizado
    inputsPoliza.tasaVentaAnual = data.tasaVentaAnual / 100
    let inicioPoliza = moment(inputsPoliza.fechaInicioPago).subtract(data.periodoDiferido, 'months')
    inputsPoliza.mesSolicitud = (currentDate.getMonth() + 1)-(inicioPoliza.month() + 1)+currentDate.getFullYear()*12-(inicioPoliza.year())*12+1
    inputsPoliza.inicioPoliza = inicioPoliza.format('YYYY-MM-DD')
    // eslint-disable-next-line
    inputsPoliza.tasaVentaMensual = (1 + (data.tasaVentaAnual / 100))**(1 / 12)-1
    // CALCULADOS
    if (inputsPoliza.mesSolicitud <= inputsPoliza.periodosDiferidos) {
      inputsPoliza.rentasDoblesPorPagar = inputsPoliza.rentaDoble
    } else {
      inputsPoliza.rentasDoblesPorPagar = Math.max((inputsPoliza.rentaDoble - inputsPoliza.mesSolicitud), 0)
    }
    let rentasGarantizadasPorPagar = inputsPoliza.periodoGarantizado - Math.max(inputsPoliza.mesSolicitud, inputsPoliza.periodosDiferidos)
    inputsPoliza.totalRentasPorPagar = (rentasGarantizadasPorPagar - inputsPoliza.rentasDoblesPorPagar) * inputsPoliza.rentaMensual + inputsPoliza.rentasDoblesPorPagar * inputsPoliza.rentaDobleMonto
  },
  makeQuotation (prestamoSeleccionado) {
    // PASS THE SELECTED QUOTA
    inputsPrestamo.cuotas = prestamoSeleccionado.cuotaSeleccionada
    // MAKE THE QUOTATION
    var cronograma = []
    var periodoPrestamo = 1
    var periodoPoliza = inputsPoliza.mesSolicitud + 1
    var saldoInicial = inputsPrestamo.prestamo
    var cuotaInicial = 0
    var inicialDevolucion = 0
    var lengthOfCuota = 0

    if (inputsPoliza.periodosDiferidos == inputsPoliza.periodoGarantizado) {
      lengthOfCuota = inputsPrestamo.cuotas + 1
    } else if (inputsCalculados.valorFuturoPrestamoAdicional > 0) {
      lengthOfCuota = inputsPrestamo.cuotas + 1
    } else {
      lengthOfCuota = inputsPrestamo.cuotas
    }

    for (var i = 0; i < lengthOfCuota; i++) {
      var vaPrestamo = inputsPrestamo.cuotasDobles === 'NO' ? inputsCalculados.valorFuturoPrestamoAdicional : inputsCalculados.valorFuturoPrestamoAdicionalDoble
      var cuota = 0
      var z3 = 0

      if (inputsPrestamo.cuotasDobles === 'SI') {
        // eslint-disable-next-line
        if (periodoPrestamo <= inputsPrestamo.periodoGracia + mesesDobles) {
          z3 = 2
        } else {
          z3 = 1
        }
      } else {
        z3 = 0
      }

      if (inputsPrestamo.cuotasDobles === 'SI') {
        if (periodoPrestamo <= inputsPrestamo.periodoGracia) {
          cuota = 0
        } else {
          if (periodoPrestamo > inputsPrestamo.cuotas) {
            if (periodoPrestamo === inputsPoliza.periodoGarantizado) {
              cuota = vaPrestamo
            } else {
              cuota = 0
            }
          } else {
            cuota = inputsPrestamo.pagoSimple * z3
          }
        }
      } else {
        if (periodoPrestamo <= inputsPrestamo.periodoGracia) {
          cuota = 0
        } else {
          if (periodoPrestamo > inputsPrestamo.cuotas) {
            if (periodoPoliza === inputsPoliza.periodoGarantizado + 1) {
              if (inputsPoliza.periodoGarantizado == inputsPoliza.periodosDiferidos) {
                cuota = inputsCalculados.valorFuturoPrestamoAdicional + parseFloat(prestamoSeleccionado.cuota)
              } else {
                cuota = inputsCalculados.valorFuturoPrestamoAdicional
              }
            } else {
              cuota = 0
            }
          } else {
            if (periodoPrestamo == inputsPrestamo.cuotas) {
              if (inputsPrestamo.prestamo >= inputsCalculados.prestamoMaxGracia) {
                cuota = parseFloat(prestamoSeleccionado.cuota)
              } else {
                cuota = saldoInicial*(1+inputsCalculados.tasaPrestamoMensual)
              }
            } else {
              cuota = parseFloat(prestamoSeleccionado.cuota)
            }
          }
        }
      }
      // SOLO CALCULAR ESTOS DATOS A LA PRIMERA PASADA
      if (i === 0) {
        inicialDevolucion = inputsCalculados.valorActualDevolucion
        cuotaInicial = inputsCalculados.prestamoParaCuota
      }
      
      var interesCuota = inputsCalculados.tasaPrestamoMensual * cuotaInicial
      var prinCuota = 0
      
      if (periodoPrestamo != 0) {
        prinCuota = periodoPrestamo === inputsPrestamo.cuotas + 1 ? 0 : cuota - interesCuota
      }

      var prinDev = periodoPrestamo === inputsPrestamo.cuotas + 1 ? cuota : 0
      var interes = inputsCalculados.tasaPrestamoMensual * saldoInicial
      var interesIS = interes/1.18
      var IGV = 0
      if (cuota != 0) { IGV = interesIS*0.18 }
      var principal = cuota - interes
      var saldoFinal = saldoInicial + interes - cuota
      var finalCuota = periodoPrestamo === inputsPrestamo.cuotas + 1 ? 0 : cuotaInicial - cuota + interesCuota
      var intDev = inputsCalculados.tasaPrestamoMensual * inputsCalculados.valorActualDevolucion
      var finalDev = periodoPrestamo === inputsPrestamo.cuotas + 1 ? 0 : inicialDevolucion + intDev

      cronograma.push({
        periodoPoliza: periodoPoliza,
        periodoPrestamo: periodoPrestamo,
        saldoInicial: Math.round(saldoInicial * 100) / 100,
        interes: Math.round(interes * 100) / 100,
        // intIS: Math.round(interesIS * 100) / 100,
        intIS: Math.round(((Math.round(interes * 100) / 100) - (Math.ceil(IGV * 100) / 100))*100)/100,
        IGV: Math.ceil(IGV * 100) / 100,
        // cuotaInicial: cuotaInicial,
        // inicialDev: inicialDevolucion,
        // intCuota: interesCuota,
        principal: Math.round(principal * 100) / 100,
        // prinCuota: prinCuota,
        // prinDev: prinDev,
        cuota: Math.round(cuota * 100) / 100,
        saldoFinal: Math.round(saldoFinal * 100) / 100
        // finalCuota: finalCuota,
        // finalDev: finalDev,
        // intDev: intDev
      })

      periodoPrestamo += 1
      periodoPoliza += 1
      saldoInicial = saldoFinal
      cuotaInicial = finalCuota
      inicialDevolucion = finalDev
    }

    return cronograma
  },
  calculateMaxMinLoan () {
    var max = 0
    var cuotaMaxima = inputsPoliza.rentaMensual
    if (cuotaMaxima < 0) {
      return { min: 0, max: 0 }
    }
    var numeroMaxCuotas = inputsPoliza.periodoGarantizado - inputsPoliza.mesSolicitud
    // var tasaPrestamoAnual = inputsPoliza.tasaVentaAnual + getSpreadAnnualInterestRate()
    // SI ES SOLES o SOLES AJUSTADOS, 9.99%. SINO, 7.99%
    // 24-02-2021. Las tasas ahora son 7.99% y 7.49%
    // 14-08-2023. Las tasas ahora son 9% y 7%
    // 19-01-2024. Las tasas ahora son 10% y 8%
    var tasaPrestamoAnual = (inputsPoliza.codigoMoneda == '001' || inputsPoliza.codigoMoneda == '013') ? 0.10 : 0.08 // ? 0.0999 : 0.0799
    var tasaPrestamoMensual = (1 + tasaPrestamoAnual)**(1/12)-1
    if ((inputsPoliza.periodosDiferidos-inputsPoliza.mesSolicitud) < 0) {
      inputsPrestamo.periodoGraciaExtraDiferido = 0
    } else {
      inputsPrestamo.periodoGraciaExtraDiferido = inputsPoliza.periodosDiferidos-inputsPoliza.mesSolicitud
    }
    //-- IGUALANDO CANTIDAD EN PERIODOS DE GRACIA.
    inputsPrestamo.periodoGracia = inputsPrestamo.periodoGraciaExtraDiferido
    var prestamoMaxCuota = 0
    if (inputsPoliza.periodoGarantizado == inputsPoliza.periodosDiferidos) {
      prestamoMaxCuota = -PV(tasaPrestamoMensual, (numeroMaxCuotas - inputsPrestamo.periodoGraciaExtraDiferido), 0, cuotaMaxima, 0)
    } else {
      prestamoMaxCuota = -PV(tasaPrestamoMensual, (numeroMaxCuotas - inputsPrestamo.periodoGraciaExtraDiferido), cuotaMaxima, 0, 0)
    }
    var prestamoMaxGracia = 0
    if (inputsPoliza.periodoGarantizado == inputsPoliza.periodosDiferidos) {
      prestamoMaxGracia = -PV(tasaPrestamoMensual, inputsPrestamo.periodoGracia + 1, 0, prestamoMaxCuota, 0)
    } else {
      prestamoMaxGracia = -PV(tasaPrestamoMensual, inputsPrestamo.periodoGracia, 0, prestamoMaxCuota, 0)
    }
    const calculoDevolucionActual = inputsPoliza.devolucionInicial * 0.5 - (inputsPoliza.devolucionInicial - inputsPoliza.devolucionOriginal)
    var valorActualDevolucion = -PV(tasaPrestamoMensual, (inputsPoliza.periodoGarantizado - inputsPoliza.mesSolicitud + 1), 0, calculoDevolucionActual, 0)
    if (inputsPrestamo.cuotasDobles === 'NO') {
      // SIN CUOTAS DOBLES
      // CALCULANDO MAXIMO PARA PRESTARSE
      max = prestamoMaxGracia + valorActualDevolucion
    } else {
      // CON CUOTAS DOBLES
      var prestamoMaxDoble = -PV(tasaPrestamoMensual, inputsPoliza.rentasDoblesPorPagar, 0, (-PV(tasaPrestamoMensual, numeroMaxCuotas-inputsPrestamo.periodoGraciaExtraDiferido-inputsPoliza.rentasDoblesPorPagar) - FV(tasaPrestamoMensual, inputsPoliza.rentasDoblesPorPagar, inputsPoliza.rentaDoble)), 0, 0)
      var prestamoMaxDobleGracia = (prestamoMaxDoble + -PV(tasaPrestamoMensual, inputsPrestamo.periodoGracia, tasaPrestamoMensual*prestamoMaxCuota, 0, 0))
      var devolucionFinal = inputsPoliza.devolucionOriginal - valorFuturoPrestamoAdicionalDoble
      // CALCULANDO MAXIMO PARA PRESTARSE
      max = prestamoMaxDobleGracia + valorActualDevolucion
    }
    // POPULANDO EL JSON DE DATOS CALCULADOS
    inputsCalculados.prestamoMaxGracia = prestamoMaxGracia
    inputsCalculados.valorActualDevolucion = valorActualDevolucion
    inputsCalculados.tasaPrestamoMensual = tasaPrestamoMensual
    inputsCalculados.tasaPrestamoAnual = tasaPrestamoAnual
    inputsCalculados.rentasGarantizadasPorPagar = inputsPoliza.periodoGarantizado - Math.max(inputsPoliza.mesSolicitud, inputsPoliza.periodosDiferidos)
    // RETORNANDO CALCULADOS
    return { min: (inputsPoliza.codigoMoneda == '001' || inputsPoliza.codigoMoneda == '013') ? quoter.loanLimits.min.PEN : quoter.loanLimits.min.USD, max: max }
  },
  calculateMoreFields (prestamoSolicitado, cuotas) {
    inputsPrestamo.prestamo = prestamoSolicitado
    var cuotaMaxima = inputsPoliza.rentaMensual
    var prestamoParaCuota = Math.min(inputsPrestamo.prestamo, inputsCalculados.prestamoMaxGracia)
    var valorFuturoDeGracia = 0
    if (inputsPoliza.periodoGarantizado == inputsPoliza.periodosDiferidos) {
      valorFuturoDeGracia = -FV(inputsCalculados.tasaPrestamoMensual, inputsPrestamo.periodoGracia + 1, 0, Math.min(inputsPrestamo.prestamo, inputsCalculados.prestamoMaxGracia), 0) - Math.min(inputsPrestamo.prestamo, inputsCalculados.prestamoMaxGracia)
    } else {
      valorFuturoDeGracia = -FV(inputsCalculados.tasaPrestamoMensual, inputsPrestamo.periodoGracia, 0, Math.min(inputsPrestamo.prestamo, inputsCalculados.prestamoMaxGracia), 0) - Math.min(inputsPrestamo.prestamo, inputsCalculados.prestamoMaxGracia)
    }
    var valorFuturoPrestamoAdicional = -FV(inputsCalculados.tasaPrestamoMensual, inputsPoliza.temporalidad + 1 - inputsPoliza.mesSolicitud, 0, inputsPrestamo.prestamo > prestamoParaCuota ? inputsPrestamo.prestamo - prestamoParaCuota : 0, 0)
    var numeroMaxCuotas = inputsPoliza.periodoGarantizado - inputsPoliza.mesSolicitud
    var numeroMinCuotas = Math.min(Math.ceil(Math.log(1 / (1 - ((prestamoParaCuota+valorFuturoDeGracia) * inputsCalculados.tasaPrestamoMensual) / cuotaMaxima))/Math.log(1 + inputsCalculados.tasaPrestamoMensual)) + inputsPrestamo.periodoGracia, numeroMaxCuotas) || numeroMaxCuotas
    /**
     *  CALCULATE MIN MULTIPLE OF 6
     *  POPULATE ARRAY OF 3 OR 2 ITEMS MULTIPLE OF 6
     */
    var rangeCuotas = []
    var auxMinCuotas = numeroMinCuotas
    var auxMaxCuotas = numeroMaxCuotas
    if (numeroMinCuotas != numeroMaxCuotas) {
      while (auxMinCuotas < (auxMaxCuotas + 1)) {
        if ((auxMinCuotas - inputsPrestamo.periodoGraciaExtraDiferido) % 12 == 0) {
          rangeCuotas.push(auxMinCuotas)
        } else if (rangeCuotas.length > 2) {
          break
        } else if (auxMinCuotas == auxMaxCuotas) {
          rangeCuotas.push(auxMaxCuotas)
          break
        }
        auxMinCuotas++
      }
    } else {
      rangeCuotas.push(numeroMaxCuotas)
    }
    //-- CLEAN ARRAY OF QUOTAS
    if (rangeCuotas.length == 1 || rangeCuotas.length == 0) {
      if (rangeCuotas[0] == numeroMinCuotas && rangeCuotas[0] == numeroMaxCuotas) {
        rangeCuotas = rangeCuotas
      } else if (rangeCuotas[0] != numeroMinCuotas && rangeCuotas[0] == numeroMaxCuotas) {
        rangeCuotas.push(numeroMinCuotas)
      } else if (rangeCuotas[0] == numeroMinCuotas && rangeCuotas[0] != numeroMaxCuotas) {
        rangeCuotas.push(numeroMaxCuotas)
      } else {
        rangeCuotas.push(numeroMinCuotas)
        rangeCuotas.push(numeroMaxCuotas)
      }
      rangeCuotas.sort()
    }
    // SHOW POSSIBILITIES FOR LOANS WITH QUOTAS
    var listPossibilities = []
    var typeOption = ''
    // var middleCuota = Math.ceil((numeroMaxCuotas + numeroMinCuotas) / 2)
    // var rangeCuotas = middleCuota === numeroMaxCuotas ? [numeroMinCuotas, numeroMaxCuotas] : [numeroMinCuotas, middleCuota, numeroMaxCuotas]
    // var rangeCuotas = numeroMinCuotas === numeroMaxCuotas ? [numeroMaxCuotas] : rangeCuotas
    // IF USER SELECT SPECIFIC QUOTA
    if (cuotas !== null) {
      typeOption = 'Personalizado'
      rangeCuotas = [cuotas]
    } else {
      typeOption = 'Default'
    }
    // ITERATE THAT USER WISH FOR SHOW POSSIBILITIES
    for (let index = 0; index < rangeCuotas.length; index++) {
      inputsPrestamo.cuotas = rangeCuotas[index]
      var cuotaGracia = 0
      if (inputsPoliza.periodoGarantizado == inputsPoliza.periodosDiferidos) {
        cuotaGracia = prestamoParaCuota + valorFuturoDeGracia
      } else {
        cuotaGracia = -PMT(inputsCalculados.tasaPrestamoMensual, inputsPrestamo.cuotas - inputsPrestamo.periodoGracia, prestamoParaCuota + valorFuturoDeGracia, 0, 0)
      }
      // CALCULATE FECHA INICIO PRESTAMO/PAGO AND FORMAT
      var inicioPagoPrestamo = null
      var fechaInicioPago = moment(inputsPoliza.fechaInicioPago)
      var fechaInicioPrestamo = moment(inputsPoliza.inicioPoliza).add(inputsPoliza.mesSolicitud, 'months').startOf('month')
      if (fechaInicioPago.isSameOrAfter(fechaInicioPrestamo)) {
        inicioPagoPrestamo = fechaInicioPago
      } else {
        inicioPagoPrestamo = fechaInicioPrestamo
      }
      // CALCULO FECHA FIN PRESTAMO AND FORMAT
      var fechaFinPrestamo = null
      if (inputsPoliza.periodosDiferidos == inputsPoliza.periodoGarantizado) {
        fechaFinPrestamo = fechaInicioPrestamo.clone().add(rangeCuotas[index], 'months').endOf('month')
      } else if ((valorFuturoPrestamoAdicional > 0)) {
        fechaFinPrestamo = fechaInicioPrestamo.clone().add(rangeCuotas[index], 'months').endOf('month')
      } else {
        fechaFinPrestamo = fechaInicioPrestamo.clone().add(rangeCuotas[index] - 1, 'months').endOf('month')
      }
      // FOR PUT TEXT IN YEARS THE NUMBERS OF QUOTAS
      var anioCuota = ((rangeCuotas[index] - inputsPrestamo.periodoGraciaExtraDiferido)/12).toFixed(1).split('.')
      var textAnioCuota = ""
      if (anioCuota.length > 1 && parseInt(anioCuota[1]) > 0) {
        textAnioCuota = anioCuota[0] + " años y " + anioCuota[1] + " meses"
      } else {
        textAnioCuota = anioCuota[0] + " años"
      }
      listPossibilities.push({
        minCuotas: numeroMinCuotas,
        maxCuotas: numeroMaxCuotas,
        periodoGraciaExtraDiferido: inputsPrestamo.periodoGraciaExtraDiferido,
        prestamoMaxGracia: inputsCalculados.prestamoMaxGracia,
        cuotaSeleccionada: rangeCuotas[index],
        textoCuotaSeleccionada: textAnioCuota,
        cuota: roundNumber(cuotaGracia, 2),
        tasaPrestamo: inputsCalculados.tasaPrestamoAnual,
        devolucionOriginal: inputsPoliza.devolucionOriginal,
        devolucionFinal: parseFloat((inputsPoliza.devolucionOriginal - valorFuturoPrestamoAdicional).toFixed(2)),
        rentaPagadaMensual: inputsPoliza.rentaMensual,
        periodoDiferido: inputsPoliza.periodosDiferidos,
        fechaInicioPrestamoMoment: fechaInicioPrestamo,
        fechaInicioPrestamo: fechaInicioPrestamo.locale('es').format('MMMM YYYY').charAt(0).toUpperCase() + fechaInicioPrestamo.locale('es').format('MMMM YYYY').slice(1),
        fechaInicioPago: inicioPagoPrestamo,
        fechaFinPago: fechaFinPrestamo.locale('es').format('MMMM YYYY').charAt(0).toUpperCase() + fechaFinPrestamo.locale('es').format('MMMM YYYY').slice(1),
        opcion: typeOption
      })
    }
    // ALMACENANDO CALCULADOS
    inputsCalculados.prestamoParaCuota = prestamoParaCuota
    inputsCalculados.valorFuturoPrestamoAdicional = valorFuturoPrestamoAdicional
    if (inputsPrestamo.cuotasDobles === 'SI') {
      // CON CUOTAS DOBLES
      var prestamoMaxDoble = -PV(inputsCalculados.tasaPrestamoMensual, inputsPoliza.rentasDoblesPorPagar, 0, (-PV(inputsCalculados.tasaPrestamoMensual, numeroMaxCuotas-inputsPrestamo.periodoGraciaExtraDiferido-inputsPoliza.rentasDoblesPorPagar) - FV(inputsCalculados.tasaPrestamoMensual, inputsPoliza.rentasDoblesPorPagar, inputsPoliza.rentaDoble)), 0, 0)
      var prestamoMaxDobleGracia = (prestamoMaxDoble + -PV(inputsCalculados.tasaPrestamoMensual, inputsPrestamo.periodoGracia, inputsCalculados.tasaPrestamoMensual*prestamoMaxCuota, 0, 0)).toFixed(2)
      var prestamoParaCuotaDoble = Math.min(prestamoMaxDobleGracia, inputsPrestamo.prestamo)
      var valorFuturoPrestamoAdicionalDoble = -FV(inputsCalculados.tasaPrestamoMensual, inputsPoliza.periodoGarantizado, 0, inputsPrestamo.prestamo > prestamoParaCuotaDoble ? inputsPrestamo.prestamo - prestamoParaCuotaDoble : 0)
      // POPULANDO DATO CALCULADO PARA CUOTA DOBLE
      inputsCalculados.valorFuturoPrestamoAdicionalDoble = valorFuturoPrestamoAdicionalDoble
    }

    return listPossibilities
  }
}

export default quoter



// WEBPACK FOOTER //
// ./src/interfaces/quoter.js